import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { decryptResponse } from "src/app/core/constants/constants";
import { PaymentService } from "src/app/pages/shared/services/payment.service";

@Component({
    selector: "app-recurring-bank-payment",
    templateUrl: "./recurring-bank-payment.component.html",
    styleUrls: ["./recurring-bank-payment.component.scss"],
    standalone: false
})
export class RecurringBankPaymentComponent implements OnInit, OnDestroy {
  banks: any;

  clientId: string;
  clientRef: string;

  destroy$ = new Subject();
  sortCode: string = "";

  fullName: string;
  accountNumber: string;

  @Output() emitBankPayment = new EventEmitter();
  decryptedValue: any;
  constructor(
    private payservice: PaymentService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.clientId = param.clientId;
      this.clientRef = param.ref;
    });
    this.route.queryParams.subscribe((param) => {
      this.decryptedValue = decryptResponse(param.q);
    });
    this.getBanks();
  }

  getBanks() {
    this.payservice.getBanks().subscribe((data) => {
      this.banks = data;
    });
  }

  getAccountDetails(accNumber: string) {
    if (accNumber.length === 10) {
      this.payservice
        .verifyBankAccount(accNumber, this.sortCode, this.clientId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
					next: (res) => {
						this.fullName = res[0].fullname;
					},
					error: (err) => {
						const errorMessage = err?.error?.responseMessage ?? "An error occured, please try again";
						this.toastr.error(errorMessage);
					}
				});
    }
  }

  makePayment() {
    const payload: any = {
      clientId: this.clientId,
      reference: this.clientRef,
      accountNumber: this.accountNumber,
      bankCode: this.sortCode,
      channel: "ACCOUNT",
      accountName: this.fullName,
      narration: this.decryptedValue.planName,
      address: this.decryptedValue.address,
    };

    this.emitBankPayment.emit(payload);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
